import {
	SIDE_NAV_LIGHT,
	//NAV_TYPE_SIDE,
	DIR_LTR,
	NAV_TYPE_TOP,
} from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig';

export const APP_NAME = 'Recluta';
export const API_BASE_URL = `${env.API_ENDPOINT_URL}${env.API_CLIENT_URL}`;
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const PUBLIC_PREFIX_PATH = '/public';
export const REDIRECT_URL_KEY = 'redirect';
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/home`;
export const UNAUTHENTICATED_ENTRY = '/login';

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'es',
	navType: NAV_TYPE_TOP,
	topNavColor: '#3e82f7',
	headerNavColor: '#082235',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false,
};
